@if (readyToRender) {
  <div
    class="outer-wrap"
    [class.multi-step-mode]="isShowingMultipleSteps"
  >
    <div
      class="inner-wrap"
    >
      @for (step of stepArr; track step.id; let i = $index) {
        <div
          class="bubble-wrap"
          [style.order]="stepIdOrder[step.id]"
        >
          <moti-convo-bubble
            [id]="'step-'+step.id"
            [step$]="step$Arr[i]"
            [isLatestStep]="isLatestStep"
            [user]="user"
            [rtl]="step.createdBy == user?.ID"
            [stagger]="!isShowingMultipleSteps"
            [readyToAction]="readyToAction"
            [showModel]="showModel"
            [showMetadata]="!isShowingMultipleSteps"
            [addingStep]="waitingForAddedStep"
            [deletingStep]="deletingStep === step.id"
            (clickedAdd$)="onClickAdd($event)"
            (clickedDelete$)="onClickDelete(step.id)"
          ></moti-convo-bubble>

          @if (isShowingMultipleSteps) {
            <moti-convo-bubble-options
              [step]="step"
              [asColumn]="true"
              [showModel]="true"
              [enableEmailButton]="true"
              [enableUseButton]="readyToAction && isLatestStep && step.isAlternate"
              [enableRegenButton]="isLatestStep"
              [enableDeleteButton]="step.isAlternate"
              [enableAddButton]="!step.isAlternate && stepArr.length < MAX_STEPS_PER_GROUP"
              [loadingStep]="!!step.partialOrder"
              [addingStep]="waitingForAddedStep"
              [selectingStep]="selectingPrimaryStep === step.id"
              [deletingStep]="deletingStep === step.id"
              (clickedAdd$)="onClickAdd($event)"
              (clickedUse$)="onSelectPrimary(step.id)"
              (clickedDelete$)="onClickDelete(step.id)"
            ></moti-convo-bubble-options>
          }
        </div>
      }
    </div>

    @if (isShowingMultipleSteps && primaryStep) {
      <moti-convo-step-metadata
        [step]="primaryStep"
        [showModel]="false"
        [showActions]="false"
        [readyToAction]="false"
        [user]="user"
        [rtl]="primaryStep.createdBy == user?.ID"
      ></moti-convo-step-metadata>
    }
  </div>
}

